var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDB897C3-6B1B-4479-BB0E-8646BE8307F2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast",
    transform: "translate(-120.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.000000, 490.000000)",
    id: "icon/ic-warning"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63610508,3.29773321 L1.88043841,15.014189 C1.5970048,15.5241114 1.59531254,16.1519836 1.87599301,16.6635469 C2.15667348,17.1751102 2.67756881,17.4935284 3.24433333,17.5 L16.7556667,17.5 C17.3224312,17.4935284 17.8433265,17.1751102 18.124007,16.6635469 C18.4046875,16.1519836 18.4029952,15.5241114 18.1195616,15.014189 L11.3638949,3.29773321 C11.0747128,2.80246132 10.5575907,2.5 10,2.5 C9.44240931,2.5 8.92528722,2.80246132 8.63610508,3.29773321 Z",
    id: "Mask",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,13.3333333 C10.4602373,13.3333333 10.8333333,13.7064294 10.8333333,14.1666667 C10.8333333,14.626904 10.4602373,15 10,15 C9.53976271,15 9.16666667,14.626904 9.16666667,14.1666667 C9.16666667,13.7064294 9.53976271,13.3333333 10,13.3333333 Z M10,6.66666667 C10.4273632,6.66666667 10.7795893,6.98836683 10.8277269,7.40281573 L10.8333333,7.5 L10.8333333,10.8333333 C10.8333333,11.2935706 10.4602373,11.6666667 10,11.6666667 C9.5726368,11.6666667 9.2204107,11.3449665 9.17227311,10.9305176 L9.16666667,10.8333333 L9.16666667,7.5 C9.16666667,7.03976271 9.53976271,6.66666667 10,6.66666667 Z",
    id: "Combined-Shape",
    fill: "#000126"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.c8ecff1e96f8ceed0f6e857b4c2eb5bd.svg";
export { ForwardRef as ReactComponent };